import * as Yup from 'yup'

import { PASS_REGEX } from './regex'

export const PASS_VALIDATION = Yup.string()
  .min(5)
  .matches(PASS_REGEX, {
    message: 'Too weak!',
  })
  .required('Required')
